/**
 * Skeleton — 로딩 중 블록 단위 플레이스홀더.
 *
 * `<div>` 에 shimmer 배경 + 둥근 모서리. width/height/radius 는 props 로 픽셀 또는 CSS 문자열.
 * 텍스트 슬롯 교체 용: `<Skeleton width={120} height={14} />`
 * 카드 슬롯 교체 용: `<Skeleton className="block-card-skel" />` + 별도 레이아웃 CSS.
 */
export function Skeleton(props: {
	readonly width?: number | string
	readonly height?: number | string
	readonly radius?: number | string
	readonly className?: string
	readonly style?: React.CSSProperties
	readonly inline?: boolean
}) {
	const { width, height = 14, radius, className, style, inline } = props
	return (
		<span
			className={`skel${inline ? " skel--inline" : ""}${className ? ` ${className}` : ""}`}
			style={{
				width,
				height,
				borderRadius: radius,
				...style
			}}
			aria-hidden
		/>
	)
}

/** 여러 라인 텍스트 블록 — `lines` 개수만큼 라인, 마지막은 60% 폭. */
export function SkeletonText(props: {
	readonly lines?: number
	readonly width?: number | string
	readonly lineHeight?: number
	readonly gap?: number
}) {
	const { lines = 2, width = "100%", lineHeight = 12, gap = 8 } = props
	return (
		<span className="skel-text" style={{ gap }} aria-hidden>
			{Array.from({ length: lines }, (_, i) => (
				<Skeleton
					// biome-ignore lint/suspicious/noArrayIndexKey: deterministic placeholder rows
					key={i}
					width={i === lines - 1 ? "60%" : width}
					height={lineHeight}
				/>
			))}
		</span>
	)
}
